<div class="card" *blockUI="'section-block'">
    <div class="row mb-1 align-items-center">
        <div class="col-md-2 col-12">
            <div class="d-flex justify-content-start align-items-center">
                <button class="btn btn-success" rippleEffect (click)="createPersonPoint()">
                    <i data-feather="plus" class="d-sm-none d-inline-block"></i>
                    <span class="d-none d-sm-inline-block">Puantaj Ekle</span>
                </button>
            </div>
        </div>
    
        <div class="form-group col-md-4 col-sm-12">
            <div class="input-group" style="max-width: 300px;">
                <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                    placeholder="yyyy-mm-dd - yyyy-mm-dd" [value]="displayDateRange()" (click)="datepicker.toggle()"
                    (dateSelect)="onDateSelection($event)" [autoClose]="'outside'" [dayTemplate]="rangeSelectionDP"
                    outsideDays="hidden" [startDate]="fromDate!" />
                <ng-template #rangeSelectionDP let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null">
                        {{ date.day }}
                    </span>
                </ng-template>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary feather icon-calendar" (click)="datepicker.toggle()"
                        type="button"></button>
                </div>
            </div>
        </div>
    
        <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div class="d-flex justify-content-between align-items-center">
                <label class="d-flex align-items-center">
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
        </div>
    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true">

        <ngx-datatable-column name="Mesai Başlangıç">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.workStart | date:'dd.MM.yyyy HH:mm'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Mesai Bitiş">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.workEnd | date:'dd.MM.yyyy HH:mm'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Mesai Oranı">
            <ng-template ngx-datatable-cell-template let-row="row">
                %{{row.workRate ?? 0}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Ek Mesai Saati">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.overtimeHours ?? 'Yok'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Durum">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div [ngClass]="getBadgeClass(row.status)">{{getStatusText(row.status)}}</div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                    <button appDelete controller="PersonPoints" [id]="row.id"
                        (callback)="getPersonPoints(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId)"
                        class="btn btn-icon btn-flat-danger">
                        <span [data-feather]="'trash'"></span>
                    </button>
                    <button class="btn btn-icon btn-flat-warning" (click)="updatePersonPoint(row)">
                        <span [data-feather]="'edit'"></span>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>

                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>

            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>